import { Dialog, DialogTitle } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { WebhookContentTypeAlias } from 'v2/interfaces/webhook2';
import webhookService from 'v2/services/webhook2';

import type { FieldsWebHook } from 'v2/interfaces/webhook2';

import Fields from './Fields';
import { createWebhookSchema } from './validations';
import { useWebhookContext } from '../context';

import type { FormikProps } from 'formik';

const WebhookForm = () => {
  const { selectedWebhook, isFormOpen, setIsFormOpen, setSelectedWebhook, listWebhooks } = useWebhookContext();

  const onClose = useCallback(() => {
    setSelectedWebhook(null);
    setIsFormOpen(false);
  }, [setIsFormOpen, setSelectedWebhook]);

  const onSubmit = useCallback(
    async (values: Partial<FieldsWebHook>, { setSubmitting }: FormikProps<FieldsWebHook>) => {
      setSubmitting(true);

      try {
        const isNewWebhook = !!!values?._id;

        if (isNewWebhook) {
          await webhookService.createURL(values as Omit<FieldsWebHook, '_id'>);
        }

        if (!isNewWebhook) {
          await webhookService.editURL(values as FieldsWebHook);
        }

        toast.success('Webhook criado com sucesso');
        listWebhooks();
        onClose();
      } catch (e) {
        toast.error(e);
      } finally {
        setSubmitting(false);
      }
    },
    [listWebhooks, onClose]
  );

  const isEdit = !!selectedWebhook?._id;
  const titleDialog = isEdit ? 'Editar webhook' : 'Criar Webhook';

  const defaultValues: FieldsWebHook = {
    description: '',
    product_id: -1,
    url: '',
    type: 'invoice',
    content_type: WebhookContentTypeAlias.json,
  };

  const currentWebhook: FieldsWebHook = {
    ...selectedWebhook,
    content_type: selectedWebhook?.content_type || WebhookContentTypeAlias.urlencoded,
  };

  const initialValues = isEdit ? currentWebhook : defaultValues;

  return (
    <Dialog open={isFormOpen} onClose={onClose} scroll='body' maxWidth='sm'>
      <DialogTitle>{titleDialog}</DialogTitle>
      <Formik validateOnBlur initialValues={initialValues} validationSchema={createWebhookSchema} onSubmit={onSubmit}>
        <Form>
          <Fields />
        </Form>
      </Formik>
    </Dialog>
  );
};

export default WebhookForm;
